var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cnc-badge-dot"},[(_vm.isShow)?_c('div',{class:`badge-dot ${_vm.sizeBadge[_vm.size]} ${_vm.outline ? 'badge-outline' : ''}`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }